/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
import '../../common/measurement_units';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "CatalogInfoRequest": {
                        "fields": {}
                      },
                      "CatalogInfoResponseLimits": {
                        "fields": {
                          "batchUpsertMaxObjectsPerBatch": {
                            "type": "int32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "batchUpsertMaxTotalObjects": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "batchRetrieveMaxObjectIds": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "searchMaxPageLimit": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "batchDeleteMaxObjectIds": {
                            "type": "int32",
                            "id": 5,
                            "rule": "optional"
                          },
                          "updateItemTaxesMaxItemIds": {
                            "type": "int32",
                            "id": 6,
                            "rule": "optional"
                          },
                          "updateItemTaxesMaxTaxesToEnable": {
                            "type": "int32",
                            "id": 7,
                            "rule": "optional"
                          },
                          "updateItemTaxesMaxTaxesToDisable": {
                            "type": "int32",
                            "id": 8,
                            "rule": "optional"
                          },
                          "updateItemModifierListsMaxItemIds": {
                            "type": "int32",
                            "id": 9,
                            "rule": "optional"
                          },
                          "updateItemModifierListsMaxModifierListsToEnable": {
                            "type": "int32",
                            "id": 10,
                            "rule": "optional"
                          },
                          "updateItemModifierListsMaxModifierListsToDisable": {
                            "type": "int32",
                            "id": 11,
                            "rule": "optional"
                          }
                        }
                      },
                      "CatalogInfoResponse": {
                        "fields": {
                          "errors": {
                            "type": "squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "limits": {
                            "type": "squareup.connect.v2.merchant_catalog.service.CatalogInfoResponseLimits",
                            "id": 2,
                            "rule": "optional"
                          },
                          "standardUnitDescriptionGroup": {
                            "type": "squareup.connect.v2.merchant_catalog.service.StandardUnitDescriptionGroup",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "StandardUnitDescriptionGroup": {
                        "fields": {
                          "standardUnitDescriptions": {
                            "type": "squareup.connect.v2.merchant_catalog.service.StandardUnitDescription",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "languageCode": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "StandardUnitDescription": {
                        "fields": {
                          "unit": {
                            "type": "squareup.connect.v2.common.MeasurementUnit",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "abbreviation": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CatalogInfoRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CatalogInfoResponseLimits && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CatalogInfoResponse && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.StandardUnitDescriptionGroup && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.StandardUnitDescription) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CatalogInfoRequest @ squareup/connect/v2/catalog/interfaces/catalog-info.proto at 19:1
 */
export const CatalogInfoRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CatalogInfoRequest');
fixType(CatalogInfoRequest);
Builder.createAndAttachToType(CatalogInfoRequest);
/**
 * SOURCE CatalogInfoResponseLimits @ squareup/connect/v2/catalog/interfaces/catalog-info.proto at 26:1
 */
export const CatalogInfoResponseLimits = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CatalogInfoResponseLimits');
fixType(CatalogInfoResponseLimits);
Builder.createAndAttachToType(CatalogInfoResponseLimits);
/**
 * SOURCE CatalogInfoResponse @ squareup/connect/v2/catalog/interfaces/catalog-info.proto at 96:1
 */
export const CatalogInfoResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CatalogInfoResponse');
fixType(CatalogInfoResponse);
Builder.createAndAttachToType(CatalogInfoResponse);
/**
 * --
 * @desc Group of standard measurement units.
 * --
 *
 * SOURCE StandardUnitDescriptionGroup @ squareup/connect/v2/catalog/interfaces/catalog-info.proto at 114:1
 */
export const StandardUnitDescriptionGroup = $root.lookupType('squareup.connect.v2.merchant_catalog.service.StandardUnitDescriptionGroup');
fixType(StandardUnitDescriptionGroup);
Builder.createAndAttachToType(StandardUnitDescriptionGroup);
/**
 * --
 * @desc Contains the name and abbreviation for standard measurement unit.
 * --
 *
 * SOURCE StandardUnitDescription @ squareup/connect/v2/catalog/interfaces/catalog-info.proto at 127:1
 */
export const StandardUnitDescription = $root.lookupType('squareup.connect.v2.merchant_catalog.service.StandardUnitDescription');
fixType(StandardUnitDescription);
Builder.createAndAttachToType(StandardUnitDescription);